import {
  ToggleField,
  NumberField,
  SelectField,
} from '../models';

import {
  courtsAntecipeiOpt,
  frequencyAntecipeiOpt,
  weekDayAntecipeiOpt,
} from '../../../../options';

const checkToDisable = (state) => !state?.push?.value;

const Antecipei = [
  new ToggleField({
    kWord: 'push',
    label: 'Cliente possui Antecipei',
  }),
  new NumberField({
    kWord: 'antecipeiValue',
    label: 'Valor Antecipei',
    money: true,
    min: 0,
    precision: 2,
    disabled: checkToDisable,
  }),
  new NumberField({
    kWord: 'numberOfCompanies',
    label: 'Número de CNPJs monitorados',
    min: 0,
    disabled: checkToDisable,
  }),
  new NumberField({
    kWord: 'limitLegalSuits',
    label: 'Limite de Processos (Franquia)',
    min: 0,
    disabled: checkToDisable,
  }),
  new SelectField({
    kWord: 'frequency',
    label: 'Frequência de busca',
    options: frequencyAntecipeiOpt,
    disabled: checkToDisable,
    default: { label: '', value: '' },
  }),
  new SelectField({
    kWord: 'courts',
    label: 'Tribunais',
    options: courtsAntecipeiOpt,
    disabled: checkToDisable,
    default: { label: '', value: '' },
  }),
  new SelectField({
    kWord: 'weekDayAntecipei',
    label: 'Dia do Monitoramento',
    options: weekDayAntecipeiOpt,
    disabled: checkToDisable,
    default: { label: '', value: '' },
  }),
  new NumberField({
    kWord: 'aditionalLegalSuitPrice',
    label: 'Valor por processo excedente',
    min: 0,
    disabled: checkToDisable,
  }),
];

export default Antecipei;
